// Company Id and what are the permissions for that company user has

import React, { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { TEAM_PERMISSIONS } from '../constants/permissions';

const PermissionContext = createContext(null);

export const PermissionProvider = ({ children }) => {
  // get user selected company info from redux
  const { user, isAuthenticated, companies } = useSelector((state) => state.auth);

  // If no admin user, no permissions
  const getPermissions = () => {
    if (!user) {
      return {
        can: () => false,
        canAny: () => false,
        canAll: () => false,
        isPlatformAdmin: false,
        isStaff: false,
        hasPermission: () => false,
        getAllPermissions: () => ({}),
        getStaffRole: () => null,
      };
    }

    // Platform admin has all permissions
    if (user.isPlatformAdmin) {
      return {
        can: () => true,
        canAny: () => true,
        canAll: () => true,
        isPlatformAdmin: true,
        isStaff: false,
        hasPermission: () => true,
        getAllPermissions: () => Object.values(TEAM_PERMISSIONS).reduce(
          (acc, key) => ({ ...acc, [key]: true }),
          {}
        ),
        getStaffRole: () => 'platform_admin',
      };
    }

    // Staff member - check specific permissions
    const permissions = user.permissions || {};

    return {
      can: (permissionKey) => permissions[permissionKey] === true,
      
      canAny: (...permissionKeys) => {
        return permissionKeys.some(key => permissions[key] === true);
      },
      
      canAll: (...permissionKeys) => {
        return permissionKeys.every(key => permissions[key] === true);
      },
      
      isPlatformAdmin: false,
      isStaff: !!user.staffRole,
      hasPermission: (permissionKey) => permissions[permissionKey] === true,
      getAllPermissions: () => permissions,
      getStaffRole: () => user.staffRole,
    };
  };

  return (
    <PermissionContext.Provider value={getPermissions()}>
      {children}
    </PermissionContext.Provider>
  );
};

// Hook to use permissions
export const usePermissions = () => {
  const context = useContext(PermissionContext);
  
  if (context === null) {
    throw new Error('usePermissions must be used within PermissionProvider');
  }
  
  return context;
};